export class BMSGPKRouteDefs {
  public static FEATURE_PATH = "bmsgpk";
}
